// src/components/FloatingToast.tsx
import React, { useEffect, useState } from 'react';

const FloatingToast: React.FC = () => {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <img
      className="toast-cursor"
      src={`${process.env.PUBLIC_URL}/assets/toastie-logo.png`}
      alt="Toastie Icon"
      style={{
        position: 'fixed',
        top: pos.y + 10,
        left: pos.x + 10,
        width: '32px',
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    />
  );
};

export default FloatingToast;
